import script from "./NewsPageAside.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageAside.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageAside.vue?vue&type=style&index=0&id=14827190&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14827190"]])

export default __exports__